import { Injectable } from '@angular/core';
import { ofType, createEffect, Actions } from '@ngrx/effects';
import {
  sendAddAsProspect,
  sendAddAsProspectSuccess,
  sendAddAsProspectFail,
} from '@shared/add-prospect/store/add-prospect.actions';
import { SuccessAlert, DangerAlert } from '@shared/alert';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProspectService } from '@shared/services/prospect.service';
import { ProspectDto } from '@shared/models/prospect';
import { HttpStatusCode } from '@angular/common/http';

@Injectable()
export class AddProspectEffects {
  sendAddAsProspect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendAddAsProspect),
      switchMap(({ candidateId, jobId }) => {
        const application: ProspectDto = {
          candidateId,
          jobIds: [jobId],
          global: false,
        };
        return this.prospectService.post({ body: application }).pipe(
          map(() => sendAddAsProspectSuccess()),
          catchError((payload) =>
            of(sendAddAsProspectFail({ error: payload.error, status: payload.status })),
          ),
        );
      }),
    ),
  );

  sendAddAsProspectSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendAddAsProspectSuccess),
      map(() => new SuccessAlert('Candidate added as prospect!')),
    ),
  );

  sendAddAsProspectFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendAddAsProspectFail),
      map((payload) => {
        if (payload.status === HttpStatusCode.Conflict) {
          return new DangerAlert(payload.error);
        }
        return new DangerAlert('Failed adding candidate as prospect!');
      }),
    ),
  );

  constructor(private prospectService: ProspectService, private actions$: Actions) {}
}
